export default "__VITE_ASSET__C9M$XiZS__"